

    module.exports = require('./DataZoomView').extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomView.js
// module id = 921
// module chunks = 158